import { shapeKeywordsForApp } from '@/utils/product/shapeAttributes';
import { updateListingScore } from '@/utils/product/score';

import { OPERATIONS } from '@/constants/bulkEdit';
import { ATTRIBUTE } from '@/constants/attributes';

export default function keywords({ actions, operation, product, shop, userFeatures }) {
  const channel = product.get('channel');

  switch (operation.get('type')) {
    case OPERATIONS[channel].KEYWORDS.SET: {
      const value = operation.get('value');
      return {
        actions,
        product: updateListingScore({
          product: product.set(ATTRIBUTE.KEYWORDS, shapeKeywordsForApp({ channel, value })),
          shop,
          userFeatures,
        }),
      };
    }

    default: {
      return { actions, product };
    }
  }
}
